import { GuestMasterProfile, GuestMasterProfileService } from '../../guest-master-profile';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-guest-master-profile',
    templateUrl: './guest-master-profile.component.html',
    styleUrls: ['./guest-master-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class GuestMasterProfileComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private guestMasterProfileService: GuestMasterProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title,
			this.guestMasterProfile = data.guestMasterProfile;
		}

	@Input() guestMasterProfile: GuestMasterProfile;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	@Output() doUpdatePreSelected = new EventEmitter<any>();
	// data
	guestMasterProfileId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	validationMessages = {
		'guestMasterProfileId': [],
		'firstName': [
			{ type: 'required', message: 'First Name is required' }
		],
		'lastName': [
			{ type: 'required', message: 'Last Name is required' }
		],
		'emailAddress': [
			{ type: 'required', message: 'Email is required' }
		],
		'mobilePhone': []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole guestMasterProfile object
		if (this.guestMasterProfile) {
			this.guestMasterProfileId = this.guestMasterProfile.guestMasterProfileId;
			this.form1.patchValue(this.guestMasterProfile);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.guestMasterProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.guestMasterProfileService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestMasterProfile = res.data.guestMasterProfile;
						this.doAdd.emit(this.guestMasterProfile);
					},
					(err: any) => {
						console.log('guestMasterProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('guestMasterProfile: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.guestMasterProfileService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestMasterProfile = res.data.guestMasterProfile;
						//if guestMasterProfileId is preent (Clicked from Quote Email Box Directly)
						// not need to open guest Profile List
						if (this.guestMasterProfileId){
							this.doUpdatePreSelected.emit(this.guestMasterProfile);
						}
						else {
							this.doUpdate.emit(this.guestMasterProfile);
						}
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.guestMasterProfileService.delete(this.guestMasterProfile.guestMasterProfileId)
				.subscribe(
					(res: any) => {
						console.log('guestMasterProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.guestMasterProfile);
					},
					(err: any) => {
						console.log('guestMasterProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			guestMasterProfileId: [this.guestMasterProfileId],
			firstName: ['', Validators.required],
			lastName: ['', Validators.required],
			emailAddress: ['', Validators.required],
			mobilePhone: [],
		});
	}
}
